import React, { useState, useRef, useEffect } from 'react';
import { IListItemProps } from '../lists/ListItem';
import { ListItemControlButtons } from '../lists/ListItemControlButtons';
import { Spinner } from 'components/Spinner';
import { Callout } from 'components/layout/Callout';
import { ActionLinks } from 'components/ActionLinks/ActionLinks';
import { IActionLinkItems, IActionLinkItem } from './../ActionLinks/ActionLinkModels';
import { useCallback } from 'react';

export interface ActionsProps {
  label: string;
  onClick: (index: number) => void;
  value: string;
}

export interface ArrayListItemProps extends IListItemProps {
  isActionBusy: boolean;
  actionLinkItems?: IActionLinkItem[];
  /**here moreActions is Menu Actions*/
  moreActions?: ActionsProps[];
}

export const LIST_ITEM_CLASS_NAME = 'dpc-array-editor__listitem';

export function ArrayListItem(props: ArrayListItemProps) {
  const [showActions, setShowActions] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef: React.MutableRefObject<HTMLButtonElement | null> = useRef(null);
  const initialRendering = useRef(true);

  useEffect(() => {
    if (initialRendering.current) {
      initialRendering.current = false;
      return;
    }
    if (props.isActionBusy) setShowActions(false);
  }, [props.isActionBusy]);

  const setClosed = useCallback(() => {
    setIsOpen(false);
    setShowActions(false);
  }, []);

  const handleOpenAction = useCallback(() => {
    setIsOpen(prevState => !prevState);
  }, []);

  const actionItems: IActionLinkItems = {
    current:
      props.moreActions &&
      props.moreActions.map(action => ({
        value: action.value,
        label: action.label,
        onClick: () => {
          action.onClick(props.index);
          setIsOpen(false);
          setShowActions(false);
          initialRendering.current = false;
        },
      })),
  };
  return (
    <li
      className={LIST_ITEM_CLASS_NAME}
      onMouseEnter={() => {
        setShowActions(true);
      }}
      onMouseLeave={() => {
        if (!isOpen) setShowActions(false);
      }}
    >
      <div className="dpc-array-editor__listitem-holder">
        <span className={`${LIST_ITEM_CLASS_NAME}-title`} title={props.hint || props.label}>
          {props.label}
        </span>
        {showActions && !props.isActionBusy && (
          <ListItemControlButtons
            index={props.index}
            onRemove={props.onRemove}
            onMoveDown={props.onMoveDown}
            onMoveUp={props.onMoveUp}
            onEdit={props.onEdit}
            onShowActions={props.moreActions && props.moreActions.length > 0 ? handleOpenAction : undefined}
            buttonRef={props.moreActions && props.moreActions.length > 0 ? buttonRef : undefined}
          />
        )}
        {props.isActionBusy && <Spinner size={15} className="dpc-icon-button__spinner" />}
      </div>
      <Callout
        isOpen={isOpen}
        onClose={setClosed}
        sourceRef={buttonRef}
        placement="left"
        showArrow={true}
        flipBehavior="flip"
      >
        <ActionLinks values={actionItems} />
      </Callout>
    </li>
  );
}
